import React from 'react';

import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const ListHeader = styled('div')(() => ({
  maxWidth: '580px',
  margin: '40px 0',
}));

const PageHeader = styled('div')(() => ({
  maxWidth: '750px',
  marginBottom: '40px',
}));

export const ProjectListHeader: React.FC = () => (
  <ListHeader>
    <Typography variant="subtitle1">Projects</Typography>
  </ListHeader>
);

export const ProjectPageHeader: React.FC = () => (
  <PageHeader>
    <Typography variant="h1">Projects</Typography>
  </PageHeader>
);
